import { Instance } from 'mobx-state-tree';
import { ProjectRouteStopScheduledDtoModelBase } from './ProjectRouteStopScheduledDtoModel.base';

/* The TypeScript type of an instance of ProjectRouteStopScheduledDtoModel */
export interface ProjectRouteStopScheduledDtoModelType extends Instance<typeof ProjectRouteStopScheduledDtoModel.Type> {}

/* A graphql query fragment builders for ProjectRouteStopScheduledDtoModel */
export { selectFromProjectRouteStopScheduledDto, projectRouteStopScheduledDtoModelPrimitives, ProjectRouteStopScheduledDtoModelSelector } from './ProjectRouteStopScheduledDtoModel.base';

/**
 * ProjectRouteStopScheduledDtoModel
 *
 * Route scheduled a stop
 */
export const ProjectRouteStopScheduledDtoModel = ProjectRouteStopScheduledDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
